import React, { useEffect, useRef, useState } from "react"
import { useTheme } from '~/contexts/ThemeContext'

import Hero from './hero'
import TwoImages from './two-images'
import Journal from './journal'
import Products from './products'
import CarouselProducts from '~/components/carousel/carousel_products'
import FullBleed from './full-bleed'
import CatsCarou from './cats-carou'
import { TxtBlock } from './randoms'

import { homewr } from "~/styles/home/home.module.scss"

const Blocks = ({ data }) => {
  const { gender } = useTheme()

  const homeRef = useRef(null)

  const multi_fullbleed = data.filter(x => x.type === 'full_bleed')
  if (multi_fullbleed.length > 1) {
    data.forEach(x => {
      if (x.type === 'full_bleed') x['multi'] = true
    })
  }
  
  const build_blocks = () => {
    const curr_gender = gender ? gender : 'men'
    return data.filter(x => x.gender === curr_gender)
  }

  const [currGender, setCurrGender] = useState(gender)
  const [didLoad, setDidLoad] = useState(false)
  const [blocks, setBlocks] = useState(build_blocks())

  const set_params = () => {
    if (typeof window === 'undefined') return
    const params = new URLSearchParams(window.location.search)
    params.set('g', gender)
    window.history.replaceState(null, null, `?${params.toString()}`);
  }

  useEffect(() => {
    const new_blocks = build_blocks()
    setBlocks(new_blocks)
    set_params()
    setDidLoad(true)

    return () => {
      document.querySelector('#header')?.removeAttribute('full')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (currGender === gender) return

    const new_blocks = build_blocks()
    setBlocks(new_blocks)
    set_params()
    setCurrGender(gender)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gender])

  return (
    <div className={homewr} style={{minHeight: '90vh'}} ref={homeRef}>
      {didLoad && blocks.map((block, index) => {
        switch (block.type) {
          case 'hero':
            return (
              <Hero 
                key={`block${block.id}$`} 
                block={block} 
                index={index} 
              />
            )
          case 'hero_wide':
            return (
              <Hero 
                key={`block${block.id}`} 
                block={block} 
                index={index} 
              />
            )
          case 'two_img':
            return (
              <TwoImages 
                key={`block${block.id}`} 
                block={block} 
                index={index} 
              />
            )
          case 'two_off':
            return (
              <TwoImages 
                key={`block${block.id}`} 
                block={block} 
                index={index} 
              />
            )
          case 'text':
            return <TxtBlock key={`block${block.id}`} block={block} index={index} />;
          case 'journal':
            return (
              <Journal 
                key={`block${block.id}`} 
                block={block} 
                index={index} 
              />
            )
          case 'products':
            return (
              <React.Fragment key={`block${block.id}`}>
                {(block.carousel) ? (
                  <CarouselProducts block={block} index={index} is_blog={false} />
                ) : (
                  <Products block={block} index={index} />
                )}
              </React.Fragment>
            )
          case 'full_bleed':
            return (
              <FullBleed 
                key={`block${block.id}`} 
                block={block} 
                index={index} 
              />
            )
          case 'category_carousel':
            return <CatsCarou key={`block${block.id}`} block={block} index={index} />;
          default:
            return <React.Fragment key={`block${block.id}`} />
        }
      })}
    </div>
  )
}

export default Blocks


